import { AxiosInstance } from 'axios';

import * as common from '../../../../../../typings/api/skymap/rest/v1/.common';
import * as types from '../../../../../../typings/api/skymap/rest/v1/coordinate-system';

export class CoordinateSystemService implements types.Handlers {
  constructor(private axios: AxiosInstance) {}

  async getCoordinateSystems(
    params: types.GetCoordinateSystemsParameters,
  ): Promise<common.GetCoordinateSystemListResponse> {
    const { data } =
      await this.axios.get<common.GetCoordinateSystemListResponse>(`/v1/coordinate-systems`);
    return data;
  }
}
